import React, {useState, useEffect, useLayoutEffect,useMemo,useRef} from 'react';
import './App.css';
import { isMobile } from 'react-device-detect';
import { Link } from 'react-router-dom';


const Eventy =({prefect})=>{
const [dasi, setdasi] = useState(false);
const [mona, setmona] = useState(true);
const [shut, setshut] = useState([]);
const [noups, setnoups]= useState(false);
const [houps, sethoups]= useState(false);

const adaan = isMobile ? "maaan" : "naaan";

const moveon = useRef();
const juka = useRef(null);
const moke = useRef(null);

// const moretwo = prefect?.length === 2 ? [...prefect , ...prefect] : prefect;

const moretwo = useMemo(() => {
    return prefect?.length === 2 ? [...prefect, ...prefect] : prefect?.length > 0 ? prefect : [{image: "해양관광상품_s.png", title : "돌파공모 환영해요!!", link : "#"}];
}, [prefect]);

const sono = () => {
    if (!moveon.current) return;
    clearTimeout(juka.current);
    clearTimeout(moke.current);
     const monzy = 100 / moretwo?.length;
     const mabos = moretwo?.length % 2 == 0 ? monzy / 2 : 0;
     
     moveon.current.style.transition = 'none';
     moveon.current.style.transform = `translateX(-${mabos}%)`;
     void moveon.current.offsetWidth;
 
     requestAnimationFrame(() => {
         moveon.current.style.transition = 'transform 0.5s ease-out';
         moveon.current.style.transform = `translateX(-${monzy + mabos}%)`;
     });
 
     juka.current = setTimeout(() => { 
         if(moveon.current == null) return;
         moveon.current.appendChild(moveon.current.firstElementChild);
         moveon.current.style.transition = 'none';
         moveon.current.style.transform = `translate(-${mabos}%)`;
     
         moke.current = setTimeout(() => {
             moveon.current.style.transition = 'transform 0.5s ease-out';
             setmona(!mona);
         }, 20);     
     }, 800);
 };

const kuara = () => {
    setdasi(true);
};

const kirara = () => {
    setdasi(false);
};

const mahina = ()=>{
    setdasi(true);
};

const amena =()=>{
    setdasi(false);
};

const noflow = () =>{
    if(noups){
        return noups;
    }else{
        setnoups(true);
        return false;
    }
};

const ahflow = () =>{
    if(houps){
        return houps;
    }else{
        sethoups(true);
        return false;
    }
};

const supo = () => {
    if(noflow()) return;
    setdasi(true);
   
    const monzy = 100 / moretwo?.length;
    const mabos = moretwo?.length % 2 == 0 ? monzy / 2 : 0;
    moveon.current.style.transition = 'none';
    moveon.current.style.transform = `translate(-${mabos}%)`;
    void moveon.current.offsetWidth;

    requestAnimationFrame(() => {
    moveon.current.style.transition = 'transform 0.5s ease-out';
    moveon.current.style.transform = `translateX(-${monzy + mabos}%)`;
    });
      
    const juki = setTimeout(() => {
        moveon.current.appendChild(moveon.current.firstElementChild);
        moveon.current.style.transition = 'none';
        moveon.current.style.transform = `translate(-${mabos}%)`;
    
        const moa = setTimeout(() => {
            moveon.current.style.transition = 'transform 0.5s ease-out';
            setnoups(false);
        }, 20);
       clearTimeout(juki);
    }, 800);
};

const sdwo = () => {
    if(ahflow()) return;
    setdasi(true);
    const monzy = 100 / moretwo?.length;
    const mabos = moretwo?.length % 2 == 0 ? monzy / 2 : 0;

    moveon.current.style.transition = 'none';
    moveon.current.style.transform = `translateX(-${mabos}%)`;
    void moveon.current.offsetWidth;
    
    requestAnimationFrame(() => {
    moveon.current.style.transition = 'transform 0.5s ease-out';
    moveon.current.style.transform = `translateX(${monzy - mabos}%)`;
    });
  
    const juki = setTimeout(() => {
        moveon.current.prepend(moveon.current.lastElementChild);
        moveon.current.style.transition = 'none';
        moveon.current.style.transform = `translate(-${mabos}%)`;
        
        const moa = setTimeout(() => {
            moveon.current.style.transition = 'transform 0.5s ease-out';
            sethoups(false);
        }, 20);
        clearTimeout(juki);
    }, 800);
};

useEffect(() => {
    if (dasi == true) return;
    if (!prefect?.length) return;
    if(prefect?.length <= 1) return;
    const kci = setTimeout(() => { sono(); }, 3500);
    return () => { clearTimeout(kci); };
},
    [mona, dasi, prefect]);

// useLayoutEffect(()=>{
//     suggle(prefect);
// },[prefect]);    

// const suggle =(arar)=>{
//     for (let i = arar?.length - 1; i > 0; i--){
//         let j = Math.floor(Math.random() * (i + 1));
//         [arar[i], arar[j]] = [arar[j], arar[i]];
//       };
//       setshut(arar);
// };

return(
<div className={adaan}>
<div className="noewa">
    {moretwo && <div className='slidm' ref={moveon} onMouseOver={kuara} onMouseOut={kirara} style={{ '--mount': moretwo ? moretwo?.length : 1, '--manoo': moretwo?.length%2 == 1 ? 0 : 1 }}>
        {moretwo?.length > 0 && moretwo.map((con, i)=>{ return (<div className='iwarem'>
            <Link to={`eika/${con.link}`} className="undwa">
            <img src={process.env.PUBLIC_URL+`/document/${con.image}`} />
            <div className='fly iwangz'>
                <p className='fly2'>{con.title}</p>
            </div>
            </Link>
        </div>)})}
    </div>}
    {prefect?.length > 1 && <div className='contra'>
        <span className='sape' onClick={supo} onMouseOver={mahina} onMouseOut={amena}><img src={process.env.PUBLIC_URL+'/sidel.png'}/></span>
        <span className='sdue' onClick={sdwo} onMouseOver={mahina} onMouseOut={amena}><img src={process.env.PUBLIC_URL+'/sider.png'}/></span>
    </div>}
</div>
</div>
)
};

export default Eventy;